import styled from 'styled-components';

// Images
import FacebookLogoSource from '../../../images/facebook.svg';

const FacebookLogo = styled(FacebookLogoSource)`
  max-width: 100%;
  height: auto;

  path {
    fill: var(--colors-mischka);
    fill-opacity: 0.7;
  }
`;

export default FacebookLogo;
